const HNTOKENKEY='hntoken_key'

function setTokenhn(token){
    localStorage.setItem(HNTOKENKEY,token)
}
function getTokenhn (){
   return localStorage.getItem(HNTOKENKEY)
}

function removeTokenhn (){
    localStorage.removeItem(HNTOKENKEY)
}

export{
    setTokenhn,getTokenhn,removeTokenhn
}